import * as React from 'react';
import { View, StyleSheet, ActivityIndicator , FlatList,Dimensions} from 'react-native';
import {  Card , Snackbar , Appbar,Text } from 'react-native-paper';


class events extends React.Component {

  state ={
    data : null,
    page :1,
    loadingMore: true,
    refreshing: false,
    connectionToast:false
  }

  _handleLoadMore = () => {
    this.setState(
      (prevState, nextProps) => ({
        page: prevState.page + 1,
        loadingMore: true
      }),
      () => {
        this._fetchEvents();
      }
    );
  };

  _handleRefresh = () => {
    this.setState(
      {
        page: 1,
        refreshing: true
      },
      () => {
        this._fetchEvents();
      }
    );
  };

  _renderFooter = () => {
    if (!this.state.loadingMore) return null;

    return (
      <View
        style={{
          position: 'relative',
          width: '100%',
          paddingVertical: 10,
        }}
      >
        <ActivityIndicator animating size="large" />
      </View>
    );
  };

  _fetchEvents = () => {
    const { page } = this.state;
    fetch('https://fitwayz.ir/api/events',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit : 10,
        offset : ((page*10) -10),
      })
    })
    .then(response => response.json()).then(responseJson => {
      this.setState((prevState, nextProps) => ({
        data:
          page === 1
            ? Array.from(responseJson.data)
            : [...this.state.data, ...responseJson.data],

        loadingMore:
        responseJson.data.length < 10
            ? false : true,

        refreshing: false
      }));
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });

  }

  componentDidMount(){
    fetch('https://fitwayz.ir/api/events',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit : 10,
        offset : 0,
      })
    })
    .then(response => response.json()).then(responseJson => {
      this.setState({data : responseJson.data,
        loadingMore:
        responseJson.data.length < 10
          ? false : true,
      });
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });
  }
  
 render() {
 return (

 <View style={{height:Dimensions.get('window').height,backgroundColor:'#ebebeb'}}>

   <Appbar.Header style={{height:50,backgroundColor:'white'}} >
    <Appbar.Action icon="menu" color='#3a3635' onPress={() => this.props.navigation.openDrawer()} />
    <Appbar.Content title='اطلاعیه ها'/>
    <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {this.props.navigation.goBack()}} />
   </Appbar.Header>

   <FlatList style={styles.container} contentContainerStyle={styles.content}
   data={this.state.data}
   keyExtractor={item => item.id.toString()}
   renderItem={({ item }) => (
    <Card style={styles.card}>
    <Card.Title style={{marginHorizontal:15}} titleStyle={{fontSize:17}} title={item.name}  />
    <Card.Cover source={{uri : item.image.replace('http','https')}}/>
    <Card.Content>

      <Text style={{fontSize:12,marginTop:15}}>{item.description}</Text>
    </Card.Content>
    </Card>
   )}

   onEndReached={this._handleLoadMore}
   onEndReachedThreshold={0.5}
   initialNumToRender={10}
   ListFooterComponent={this._renderFooter}
   onRefresh={this._handleRefresh}
   refreshing={this.state.refreshing}
   />  

<Snackbar
          style={{zIndex:200}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({connectionToast:false})}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>

  </View>
      
    );
  }
}

const styles = StyleSheet.create({
  container: {
    
    backgroundColor:'#ebebeb'
  },
  content: {
    flex: 1,
    padding: 4,
  },
  card: {
    margin: 4,
  },
 
});

export default events;

